module.exports = "/_next/static/images/brother-6d69fe2ff145bc20b773afff5e8dc7c7.svg";